<template>
  <div class="credits">
    <modal-card>
      <div>
        <h1>Crédits</h1>
        <h2>Développement par</h2>
        <a href="https://alexisgj.com/">Alexis GJ</a>
        <h2>Données</h2>
        <a
          href="http://donnees.ville.montreal.qc.ca/dataset/patinoires"
          target="_blank"
          >Données ouvertes MTL</a
        ><br />
        <a href="https://creativecommons.org/licenses/by/4.0/" target="_blank"
          >Licence CC BY 4.0</a
        >
      </div>
    </modal-card>
  </div>
</template>

<style scoped>
.credits {
  font-family: "Montserrat", sans-serif;
  text-align: center;
}

h1 {
  font-family: "Staatliches", cursive;
  font-size: 2.5em;
  line-height: 0.9em;
  margin: 0;
}
h2 {
  font-family: "Montserrat", sans-serif;
  font-size: 1em;
}
a {
  color: #000 !important;
  font-weight: bold;
  font-family: "Staatliches", cursive;
  font-size: 1.4em;
}

.credits-dialog {
  padding: 10px;
}
</style>

<script>
import ModalCard from "../components/ModalCard";

export default {
  name: "credits",
  head: {
    title: {
      inner: "Crédits"
    },
    link: [{ rel: "canonical", href: "https://patinoires.ca/credits" }]
  },
  components: {
    ModalCard
  },
  data: () => ({
    showDialog: false
  }),
  methods: {}
};
</script>
